var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisabledUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7157 20.2157L76.2843 76.7843M8 48.5C8 70.5914 25.9086 88.5 48 88.5C70.0914 88.5 88 70.5914 88 48.5C88 26.4086 70.0914 8.5 48 8.5C25.9086 8.5 8 26.4086 8 48.5Z",
    stroke: "#FE7A7A",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledUserIcon);
export default __webpack_public_path__ + "static/media/disabledUser_icon.8049d0c9baa0dfb2973d93ce96ccd65c.svg";
export { ForwardRef as ReactComponent };